import styled from "styled-components";

export const StyledRow = styled.div`
  width: 100%;
  padding: 10px 0;
  border-bottom: 1px solid #e1e1e4;

  display: grid;
  align-items: center;
  grid-template-columns: repeat(5, 1fr);

  gap: 16px;

  & > *:first-child {
    grid-column: span 2;
  }

  @media (min-width: 768px) {
    margin-bottom: 30px;
    grid-template-columns: repeat(9, 1fr);
    gap: 10px;

    & > *:first-child {
      grid-column: span 3;
    }

    & > div:not(:first-child) {
      justify-self: center;
      grid-column: span 2;
    }
  }
`;

export const Cell = styled.div``;

export const DetailsBlock = styled.div`
  gap: 12px;
  display: flex;
  gap: 0;
  align-items: stretch;
  flex-direction: column;

  @media (min-width: 768px) {
    flex-direction: row;
    gap: 20px;
  }
`;

export const ImageBlock = styled.figure`
  margin: 0;
  width: 50px;
  height: auto;
  font-size: 10px;
  position: relative;

  @media (min-width: 768px) {
    width: 80px;
  }
`;
export const CloseIcon = styled.img`
  position: absolute;
  right: -5px;
  top: -5px;
  cursor: pointer;
`;

export const StyledImage = styled.img`
  width: 50px;
  height: auto;

  @media (min-width: 768px) {
    width: 80px;
  }
`;

export const PriceCell = styled.div`
  font-size: clamp(0.625rem, 0.5341rem + 0.4545vw, 0.875rem);
`;

export const QuantityCell = styled.div``;

export const SelectButton = styled.div`
  display: flex;
  align-items: center;
  background: #f0eff2;
  width: 50px;

  @media (min-width: 768px) {
    width: 80px;
  }
`;

export const SpanButton = styled.button`
  cursor: pointer;
  border: none;
  background: #e7e7e7;
  padding: 4px;
  font-size: 1rem;
  color: #767678;

  &.disabled {
    opacity: 0.45;
    pointer-events: none;
    cursor: not-allowed;
  }

  @media (min-width: 768px) {
    padding: 5px 6px;
  }
`;

export const Value = styled.span`
  padding: 5px;
  color: #767678;
  flex-grow: 1;
  text-align: center;
  font-size: clamp(0.625rem, 0.5341rem + 0.4545vw, 0.875rem);
  &.disabled {
    color: #bebfc2;
  }

  @media (min-width: 768px) {
    padding: 5px 12px;
  }
`;

export const DetailsCell = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (min-width: 768px) {
    gap: 6px;
  }
`;

export const Name = styled.h3`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  font-weight: 400;
  font-size: clamp(0.75rem, 0.6136rem + 0.6818vw, 1.125rem);
  line-height: 1.25;
  margin-bottom: 5px;
  color: #000000;

  @media (min-width: 768px) {
    -webkit-line-clamp: 2;
  }
`;
export const Text = styled.h6`
  font-weight: 400;
  font-size: clamp(0.625rem, 0.5341rem + 0.4545vw, 0.875rem);
  line-height: 17px;
  color: #a1a8c1;
  text-transform: capitalize;
`;
